import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { OrderService } from '../../order/order.service';
import { UserService } from '../../../core/services/user.service';
import { BaseComponent } from '../../../app.base.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AppCacheService } from '../../../core/services/cache/app-cache.service';
import { AppConfigService } from '../../../core/services/init/app-config.service';
import { GoogleAnalyticsService } from '../../../core/services/google-analytics.service';

@Component({
  selector: 'par-add-to-cart',
  templateUrl: './add-to-cart.component.html',
  styleUrls: ['./add-to-cart.component.scss']
})
export class AddToCartComponent extends BaseComponent implements OnInit {
  private selectedOrder: any;
  private newOrderObject: any = {
    orderNum: 'New Order',
    poNum: '',
    createdDate: '',
    createdBy: ''
  };
  orderColumns = ['select', 'orderNo', 'poNumber', 'createdDate', 'createdBy'];
  orderColumnsMobile = ['select', 'orderNo', 'createdDate'];
  ordersList: any;
  orderSelected: Boolean = true;
  defaultAccount: any;
  /***************Properties***************/

  /***************Constructor***************/
  constructor(
    public dialogRef: MatDialogRef<AddToCartComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private orderService: OrderService,
    private userService: UserService,
    deviceDetectorService: DeviceDetectorService,
    private cache: AppCacheService,
    private appConfig: AppConfigService,
    private gAnalytics: GoogleAnalyticsService
  ) {
    super(deviceDetectorService, cache, appConfig);
  }

  ngOnInit() {
    const maxOpenOrders = this.userService.getDefaultAccountMasterData()
      .maxOpenOrders;
    this.ordersList = this.data.openOrders;
    this.defaultAccount = this.userService.getDefaultAccount();
    if (this.ordersList.length < maxOpenOrders) {
      this.ordersList.push(this.newOrderObject);
    }
  }
  /***************Constructor***************/

  /***************Component Methods***************/

  onClose() {
    this.dialogRef.close(false);
  }

  onOrderSelect(entry) {
    this.selectedOrder = Object.assign({}, entry);
    this.orderSelected = true;
  }

  onOrderSubmit() {
    if (!this.selectedOrder) {
      this.orderSelected = false;
      return;
    }

    const order =
      this.selectedOrder.orderNum === this.newOrderObject.orderNum
        ? null
        : this.selectedOrder;

    this.orderService
      .addToCart(this.data.orderDetails, order)
      .subscribe((response: any) => {
        if (!response.hasError) {
          if (this.appConfig.gTrackingId) {
            this.gAnalytics.logAddToCart(this.data.orderDetails, this.defaultAccount.accountSoldToNum);
          }
          this.orderService.cartCountUpdate();
          this.dialogRef.close(response);
        }
      });
  }

  /***************Component Methods***************/
}
